import apiService from './api';

class YouTubeChannelService {
    // Check if YouTube API is configured
    async getApiStatus() {
        return await apiService.get('/api/youtube/status');
    }

    // Preview channel videos (first page)
    async previewChannel(channelInput) {
        return await apiService.post('/api/youtube/channel/preview', { channelInput });
    }

    // Load more videos (pagination)
    async loadMoreVideos(channelId, pageToken) {
        const params = new URLSearchParams();
        params.append('channelId', channelId);
        if (pageToken) {
            params.append('pageToken', pageToken);
        }
        return await apiService.get(`/api/youtube/channel/videos?${params.toString()}`);
    }

    // Import selected videos to gallery
    async importVideos(galleryId, videos) {
        return await apiService.post(`/api/galleries/${galleryId}/import/youtube-channel`, { videos });
    }
}

// Create singleton instance
const youtubeChannelService = new YouTubeChannelService();
export default youtubeChannelService;
